import { CameraPreview } from '@capacitor-community/camera-preview';
import moment from 'moment';

export function startPreview() {
  window.screen.orientation.lock('portrait');
  const cameraPreviewOptions = {
    parent: 'previewPhoto',
    position: 'rear',
    height: window.screen.height - 125,
    width: '100%',
    enableZoom: true,
    disableExifHeaderStripping: false // pour ne pas perdre l'orientation de la photo pour android
  };
  CameraPreview.start(cameraPreviewOptions);
}

export function stopPreview() {
  window.screen.orientation.unlock();
  CameraPreview.stop();
}
export function flipCamera() {
  CameraPreview.flip();
}

export async function takePicture() {
  return new Promise((resolve, reject) => {
    CameraPreview.capture({
      quality: 90,
      height: 900,
      width: 400
    })
      .then((image) => {
        // les données ne sont pas compatibles avec le UploadFilesField
        // on convertit d'abord en blob le résultat
        const extension = image.value.charAt(0);
        const rawData = atob(image.value);
        if (extension === '/') {
          image.format = 'jpeg';
        }
        if (extension === 'i') {
          image.format = 'png';
        }
        const bytes = new Array(rawData.length);
        for (let idx = 0; idx < rawData.length; idx += 1) {
          bytes[idx] = rawData.charCodeAt(idx);
        }
        const arr = new Uint8Array(bytes);
        const blob = new Blob([arr], { type: 'image/png' });

        // pour ensuite le convertir en file
        // on ajoute un timestamp pour le nom du fichier
        const timeStamp = moment().unix();
        const file = new File([blob], `IMG_${timeStamp}.${image.format}`, {
          lastModified: timeStamp,
          type: blob.type
        });

        resolve([file]);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
}
